// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"6383cb82","747":"879abc74","888":"7f87c7fc"}[chunkId] + ".chunk.js";
};